import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Appeals from "./pages/Appeals";
import Providers from "./pages/Providers";
import Merchants from "./pages/Merchants";
import FileUpload from "./pages/FileUpload";
import ApiTest from "./pages/ApiTest";
import PaymentPageTest from "./pages/PaymentPageTest";
import BalanceTests from "./pages/BalanceTests";

function App() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/appeals" element={<Appeals />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/merchants" element={<Merchants />} />
        <Route path="/file-upload" element={<FileUpload />} />
        <Route path="/api-test" element={<ApiTest />} />
        <Route path="/payment-page" element={<PaymentPageTest />} />
        <Route path="/balance-tests" element={<BalanceTests />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;


